/* eslint-disable max-len */
export const OUR_MISSION =
    'Nossa missão é empoderar profissionais com curadoria de informações independentes e especializadas.'
export const SITE_NAME = 'JOTA – Fonte de confiança para você'
export const SITE_DESCRIPTION =
    'Informação, notícias e análises sobre Judiciário, política, projetos de lei, direito tributário, regulação. Bastidores e previsibilidade para tomadores de decisão'
export const SITE_URL = 'https://jota.info'
export const UNDEFINED = 'undefined'
export const JU_TOKEN = 'JU_TOKEN'
export const RD_BRICK = 'bricks--component-embeddable-form'
export const RD_BRICK_ITEM = 'bricks-form__fieldset'
export const PRO_TRIBUTOS = 'tributos'
export const PRO_PODER = 'poder'
export const PRO_SAUDE = 'saúde'
export const PRO_TRABALHISTA = 'trabalhista'
export const SITE_KEYWORDS_DEFAULT =
    'notícias, últimas notícias, jornalismo, atualidades, política, economia, tecnologia, saúde, notícias de hoje, cobertura ao vivo, reportagens'
export const PRO_PODER_LOGIN_TEXT_1 =
    ' Com o JOTA PRO Poder, você e sua empresa estarão sempre um passo à frente no acompanhamento dos Três Poderes.'

export const URL_CATEGORY_OPINIAO_E_ANALISE = '/opiniao-e-analise'
export const URL_CATEGORY_TRIBUTOS = '/tributos-e-empresas'

export const PRO_PODER_LOGIN_TEXT_2 =
    'Experimente grátis e tenha o melhor da análise e da inteligência política na palma da sua mão, com relatórios, alertas, calls e muito mais.'

export const PRO_TRIBUTOS_LOGIN_TEXT_1 =
    'Com o JOTA PRO Tributos, você e sua empresa estarão sempre um passo à frente nas mudanças no contencioso tributário nacional.'

export const PRO_TRIBUTOS_LOGIN_TEXT_2 =
    ' Experimente grátis e acompanhe os bastidores das discussões tributárias mais relevantes de Carf, STF, STJ e Congresso.'

export const PRO_TRABALHISTA_LOGIN_TEXT_1 =
    'Com o JOTA PRO Trabalhista, sua empresa acompanha os bastidores das mudanças no direito trabalhista, com insights do TST, STF, TRT e Legislativo.'

export const PRO_TRABALHISTA_LOGIN_TEXT_2 =
    'Experimente grátis e acompanhe os bastidores das mudanças no direito trabalhista, com insights exclusivos do TST, STF, TRT e Legislativo.'

export const SCROLL_LIMIT_NORMAL = 65
export const SCROLL_POSITION_LIMIT = 90
export const API_ALERTAS = process.env.NEXT_PUBLIC_API_ALERTAS ?? ''
export const API_JOTA_CMS = process.env.NEXT_PUBLIC_API_CMS
export const apiAlertasSuffix = (limit = 10, page = 1) =>
    `api/alerts/publications/?limit=${limit}&page=${page}`
export const apiAlertaBySlug = (slug: string) =>
    `api/alerts/publications/slug/${slug}`

/**
 * Get Description from Tag or Category
 * @param {string} name
 * @return {string}
 */
export const getDescriptionFromTagOrCategoryName = (name: string) => {
    if (!name) return ''
    const friendlyName = name.replaceAll('-', ' ')

    return `Noticias, colunas e análise sobre ${friendlyName.toUpperCase()}. As informações mais relevantes sobre ${friendlyName.toUpperCase()} com o JOTA. Jornalismo e tecnologia para tomadores de decisão.`
}

/**
 * Get Description from Author
 * @param {string} name
 * @return {string}
 */
export const getDescriptionFromAuthor = (name: string) => {
    if (!name) return ''
    const friendlyName = name.replaceAll('-', ' ')

    return `Artigos e notícias escritos por ${friendlyName.toUpperCase()} e publicadas no JOTA. Últimos artigos, notícias e colunas de opinião do JOTA.`
}

export const ESTUDIO_JOTA =
    'https://conteudo.jota.info/estudio-jota?utm_source=rd_station&utm_medium=site&utm_campaign=banner_header_topo_home_estudio_jota&utm_id=header_estudio_jota&utm_term=lp_estudio_jota&utm_term=header_topo_home_estudio_jota'
